var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoVale = function SvgLogoVale(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76.608,
    height: 26.657,
    viewBox: "0 0 76.608 26.657",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{clip-path:url(#a);}.b{fill:#008f83;}.c{fill:#f3c108;}.d{fill:#77787b;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.608,
    height: 26.657,
    transform: "translate(0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-635.74 -267.63)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M734.733,274.085c2.265,1.925,4.449,3.532,6.8,3.532a8.049,8.049,0,0,0,6.337-2.7l-14.579,19.365L715.43,270.4a11.933,11.933,0,0,1,7.775-2.777c4.574,0,8.142,3.588,11.528,6.465",
    transform: "translate(-708.506 -267.621)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M954.4,281.792a6.708,6.708,0,0,0-3.887-1.382c-4.443,0-7.22,4.442-12.908,5.354,2.265,1.925,4.449,3.532,6.8,3.532a8.049,8.049,0,0,0,6.337-2.7Z",
    transform: "translate(-911.373 -279.3)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1138.256,423.7h-1.782l-2.317,6.257c-.134.362-.215.6-.215.6h-.027s-1.822-4.581-2.76-6.859h-1.875l3.295,8.052a2.069,2.069,0,0,0,1.969,1.245Z",
    transform: "translate(-1086.399 -410.14)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1368.454,432.863v-1.447h-4.08V423.7H1362.7v9.163Z",
    transform: "translate(-1299.539 -410.14)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1456.828,432.863v-1.447h-3.873v-2.626h3.272V427.4h-3.272v-2.25h2.229a1.654,1.654,0,0,0,1.846-1.447h-5.749v9.164h5.548Z",
    transform: "translate(-1380.423 -410.14)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1245.279,432.863l-3.644-9.163h-1.593l-3.792,9.163h1.791l.916-2.331h3.536l.912,2.331Zm-3.335-3.778h-2.4l1.193-3.094.013-.054Z",
    transform: "translate(-1184.075 -410.14)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-680.071,480.955h-.489v-.385h1.474a1.941,1.941,0,0,1,.984.2,1.1,1.1,0,0,1,.557,1.015,1.255,1.255,0,0,1-1.3,1.334h-.716l-.012,1.352h.545v.386h-1.535v-.386h.465Zm.513,1.773h.574a.831.831,0,0,0,.911-.893.807.807,0,0,0-.385-.765,1.313,1.313,0,0,0-.7-.116h-.386Z",
    transform: "translate(566.194 -462.069)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-639.306,493.673h-.453v-.758a2.975,2.975,0,0,1,1.108-.244c.813,0,1.248.3,1.248,1.137,0,.275-.036,1.138-.036,1.706h.453v.386h-.905v-.129a3.273,3.273,0,0,1,.062-.557h-.012a1.019,1.019,0,0,1-1.059.758.872.872,0,0,1-.978-.9c0-.881.943-.967,2-.967v-.226c0-.593-.226-.819-.722-.819a1.954,1.954,0,0,0-.7.129v.488Zm1.425.778c-.746,0-1.5,0-1.5.593a.54.54,0,0,0,.594.545c.342,0,.905-.19.905-1.138",
    transform: "translate(529.049 -473.118)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-600.271,493.321h-.539v-.385h1.04v.17c0,.184-.036.557-.067.813h.018c.122-.465.288-1.039,1.07-1.039a1.257,1.257,0,0,1,.319.049l-.05.452a1.13,1.13,0,0,0-.342-.049c-.648,0-.936.637-.948,1.193l-.024,1.181h.532v.386h-1.481v-.386h.447Z",
    transform: "translate(493.373 -473.309)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-569.046,493.673h-.453v-.758a2.971,2.971,0,0,1,1.108-.244c.813,0,1.248.3,1.248,1.137,0,.275-.036,1.138-.036,1.706h.453v.386h-.905v-.129a3.267,3.267,0,0,1,.062-.557h-.012a1.018,1.018,0,0,1-1.058.758.872.872,0,0,1-.979-.9c0-.881.942-.967,2-.967v-.226c0-.593-.227-.819-.721-.819a1.954,1.954,0,0,0-.7.129v.488Zm1.426.778c-.746,0-1.5,0-1.5.593a.54.54,0,0,0,.593.545c.341,0,.905-.19.905-1.138",
    transform: "translate(464.893 -473.118)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-510.748,493.52h1.01c0,.574-.024,1.144-.024,1.865,0,.459.085.948.7.948.917,0,.93-1,.93-1.449V493.9h-.5v-.385h1.01l-.024,2.772h.441v.385h-.937a3.451,3.451,0,0,1,.018-.38l.049-.317h-.012a1.166,1.166,0,0,1-1.064.771c-.905,0-1.113-.575-1.113-1.291,0-.574.018-1.063.024-1.554h-.508v-.386Z",
    transform: "translate(411.138 -473.894)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-463.79,495.524h.4l.024-2.385h-.508v-.386h1.01a3.2,3.2,0,0,1-.019.379l-.049.319h.012a1.158,1.158,0,0,1,1.119-.771.887.887,0,0,1,.954.74h.012a1.066,1.066,0,0,1,1.07-.74c.869,0,1.083.587,1.083,1.186,0,.539-.025,1.169-.025,1.658h.465v.385h-1.37v-.385h.4c.005-.513.024-1.022.024-1.529,0-.459-.1-.9-.685-.9-.409,0-.9.269-.905,1.125l-.012,1.3h.453v.385h-1.376v-.385h.4c.006-.514.024-1.022.024-1.529,0-.459-.1-.9-.685-.9-.409,0-.9.269-.905,1.125l-.012,1.3h.459v.385h-1.37v-.383Z",
    transform: "translate(368.331 -473.127)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-372.711,495.524h.4l.025-2.385h-.508v-.386h1.01a3.41,3.41,0,0,1-.018.379l-.049.319h.012a1.158,1.158,0,0,1,1.119-.771.888.888,0,0,1,.954.74h.012a1.066,1.066,0,0,1,1.07-.74c.869,0,1.083.587,1.083,1.186,0,.539-.025,1.169-.025,1.658h.465v.385h-1.37v-.385h.4c.006-.513.024-1.022.024-1.529,0-.459-.1-.9-.685-.9-.41,0-.9.269-.905,1.125l-.012,1.3h.453v.385h-1.376v-.385h.4c.006-.514.024-1.022.024-1.529,0-.459-.1-.9-.686-.9-.409,0-.9.269-.905,1.125l-.012,1.3h.459v.385h-1.37Z",
    transform: "translate(285.165 -473.127)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-303.419,493.52h1.01c0,.574-.025,1.144-.025,1.865,0,.459.085.948.7.948.918,0,.93-1,.93-1.449V493.9h-.5v-.385h1.01l-.024,2.772h.44v.385h-.936a3.483,3.483,0,0,1,.018-.38l.049-.317h-.012a1.168,1.168,0,0,1-1.064.771c-.905,0-1.113-.575-1.113-1.291,0-.574.018-1.063.024-1.554h-.507v-.386Z",
    transform: "translate(221.822 -473.894)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-254.313,495.524h.4c0-.489.024-1,.024-1.511,0-.306-.012-.917-.716-.917-.447,0-.937.269-.937,1.125l-.012,1.3h.459v.385h-1.37v-.385h.4l.024-2.385h-.507v-.386h1.01a3.418,3.418,0,0,1-.018.379l-.049.319h.012a1.16,1.16,0,0,1,1.12-.771c.869,0,1.083.587,1.083,1.186,0,.539-.025,1.169-.025,1.658h.465v.385h-1.37v-.385Z",
    transform: "translate(179.015 -473.127)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-205.291,480.028h.471v.386h-.972a3.274,3.274,0,0,1,.062-.636l-.012-.011a1.073,1.073,0,0,1-1.058.721c-.722,0-1.309-.508-1.309-1.523a1.6,1.6,0,0,1,1.677-1.78,1.4,1.4,0,0,1,.654.141l.012-1.229h-.631v-.386h1.132Zm-.489-2.288a1.221,1.221,0,0,0-.618-.141c-.746,0-1.187.483-1.187,1.37,0,.587.275,1.1.887,1.1.765,0,.918-.71.918-1.328Z",
    transform: "translate(134.793 -457.631)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-162.19,492.67a1.458,1.458,0,0,1,1.529,1.566,1.548,1.548,0,0,1-1.529,1.738,1.458,1.458,0,0,1-1.53-1.566,1.549,1.549,0,0,1,1.53-1.738m0,2.887c.672,0,1-.55,1-1.235s-.331-1.236-1-1.236-1,.55-1,1.236.33,1.235,1,1.235",
    transform: "translate(94.26 -473.118)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-98.672,495.811a3.189,3.189,0,0,1-.911.152,1.5,1.5,0,0,1-1.646-1.651,1.535,1.535,0,0,1,1.579-1.653,3.047,3.047,0,0,1,1.022.159v.825h-.453v-.5a1.929,1.929,0,0,0-.526-.073c-.911,0-1.095.721-1.095,1.236a1.143,1.143,0,0,0,1.2,1.235,2.746,2.746,0,0,0,.856-.176Z",
    transform: "translate(37.199 -473.109)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-62.61,492.67a1.458,1.458,0,0,1,1.529,1.566,1.548,1.548,0,0,1-1.529,1.738,1.458,1.458,0,0,1-1.53-1.566,1.55,1.55,0,0,1,1.53-1.738m0,2.887c.672,0,1-.55,1-1.235s-.331-1.236-1-1.236-1,.55-1,1.236.33,1.235,1,1.235",
    transform: "translate(3.331 -473.118)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-22.1,495.524h.4l.024-2.385h-.507v-.386h1.01a3.421,3.421,0,0,1-.018.379l-.049.319h.012a1.158,1.158,0,0,1,1.119-.771.887.887,0,0,1,.954.74h.012a1.066,1.066,0,0,1,1.07-.74c.869,0,1.083.587,1.083,1.186,0,.539-.025,1.169-.025,1.658h.465v.385h-1.371v-.385h.4c.005-.513.024-1.022.024-1.529,0-.459-.1-.9-.686-.9-.41,0-.9.269-.905,1.125l-.012,1.3h.453v.385h-1.375v-.385h.4c.006-.514.024-1.022.024-1.529,0-.459-.1-.9-.685-.9-.409,0-.9.269-.905,1.125l-.012,1.3h.459v.385H-22.1Z",
    transform: "translate(-34.983 -473.127)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M71.116,495.524h.4c0-.489.025-1,.025-1.511,0-.306-.012-.917-.716-.917-.447,0-.936.269-.936,1.125l-.013,1.3h.458v.385H68.969v-.385h.4l.025-2.385H68.89v-.386H69.9a3.221,3.221,0,0,1-.018.379l-.05.319h.013a1.158,1.158,0,0,1,1.119-.771c.869,0,1.083.587,1.083,1.186,0,.539-.024,1.169-.024,1.658h.465v.385h-1.37Z",
    transform: "translate(-118.14 -473.127)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M118.339,492.67a1.458,1.458,0,0,1,1.529,1.566,1.549,1.549,0,0,1-1.529,1.738,1.457,1.457,0,0,1-1.529-1.566,1.548,1.548,0,0,1,1.529-1.738m0,2.887c.673,0,1-.55,1-1.235s-.33-1.236-1-1.236-1,.55-1,1.236.33,1.235,1,1.235",
    transform: "translate(-161.897 -473.118)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M154.87,493.52h1.3v.385h-.379l.728,2.025a1.91,1.91,0,0,1,.066.269h.012a1.8,1.8,0,0,1,.068-.269l.746-2.025H157v-.385h1.261v.385h-.349l-1.089,2.772h-.5l-1.1-2.772h-.355Z",
    transform: "translate(-196.65 -473.894)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M199.96,492.67a1.457,1.457,0,0,1,1.529,1.566,1.548,1.548,0,0,1-1.529,1.738,1.458,1.458,0,0,1-1.53-1.566,1.549,1.549,0,0,1,1.53-1.738m0,2.887c.672,0,1-.55,1-1.235s-.331-1.236-1-1.236-1,.55-1,1.236.33,1.235,1,1.235",
    transform: "translate(-236.425 -473.118)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M243.493,493.619h-.453l-.024-.447a1.074,1.074,0,0,0-.557-.116c-.318,0-.728.1-.728.483,0,.343.306.447.771.527.8.135,1.138.379,1.138.9,0,.563-.38,1.009-1.292,1.009a3.141,3.141,0,0,1-1.082-.189l-.024-.808h.453l.024.472a1.927,1.927,0,0,0,.716.14c.33,0,.727-.14.727-.525,0-.312-.324-.423-.666-.5-.844-.184-1.266-.33-1.266-.948,0-.508.336-.948,1.242-.948a3.262,3.262,0,0,1,1,.189Z",
    transform: "translate(-275.507 -473.118)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M294.062,493.52h1.3v.385h-.379l.728,2.025a2.026,2.026,0,0,1,.066.269h.012a1.8,1.8,0,0,1,.068-.269l.746-2.025h-.41v-.385h1.26v.385H297.1l-1.089,2.772h-.5l-1.1-2.772h-.354v-.385Z",
    transform: "translate(-323.747 -473.894)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M339.354,493.673H338.9v-.758a2.975,2.975,0,0,1,1.108-.244c.813,0,1.248.3,1.248,1.137,0,.275-.036,1.138-.036,1.706h.453v.386h-.905v-.129a3.274,3.274,0,0,1,.062-.557h-.012a1.019,1.019,0,0,1-1.059.758.872.872,0,0,1-.978-.9c0-.881.943-.967,2-.967v-.226c0-.593-.226-.819-.721-.819a1.95,1.95,0,0,0-.7.129v.488Zm1.425.778c-.746,0-1.5,0-1.5.593a.54.54,0,0,0,.593.545c.342,0,.905-.19.905-1.138",
    transform: "translate(-364.581 -473.118)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M377.592,476.095h-.612v-.385h1.113l-.024,4.317h.5v.387h-1.455v-.387h.452Z",
    transform: "translate(-399.462 -457.631)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M402.789,492.67a1.458,1.458,0,0,1,1.53,1.566,1.549,1.549,0,0,1-1.53,1.738,1.457,1.457,0,0,1-1.529-1.566,1.549,1.549,0,0,1,1.529-1.738m0,2.887c.673,0,1-.55,1-1.235s-.33-1.236-1-1.236-1,.55-1,1.236.331,1.235,1,1.235",
    transform: "translate(-421.633 -473.118)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M443.389,493.321h-.539v-.385h1.04v.17c0,.184-.037.557-.068.813h.018c.123-.465.288-1.039,1.071-1.039a1.243,1.243,0,0,1,.318.049l-.049.452a1.131,1.131,0,0,0-.342-.049c-.649,0-.937.637-.948,1.193l-.025,1.181h.533v.386h-1.48v-.386h.447Z",
    transform: "translate(-459.609 -473.309)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M474.7,494.364a1.082,1.082,0,0,0,1.2,1.193,2.158,2.158,0,0,0,.949-.238l-.018.434a2.876,2.876,0,0,1-1.04.22,1.658,1.658,0,0,1-.153-3.3c1.248,0,1.364,1.132,1.364,1.694Zm1.774-.385a.853.853,0,0,0-.838-.924.93.93,0,0,0-.937.924Z",
    transform: "translate(-488.208 -473.118)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M516.563,493.619h-.453l-.023-.447a1.076,1.076,0,0,0-.557-.116c-.318,0-.728.1-.728.483,0,.343.306.447.771.527.8.135,1.137.379,1.137.9,0,.563-.379,1.009-1.29,1.009a3.156,3.156,0,0,1-1.084-.189l-.024-.808h.453l.024.472a1.92,1.92,0,0,0,.716.14c.33,0,.728-.14.728-.525,0-.312-.324-.423-.668-.5-.844-.184-1.265-.33-1.265-.948,0-.508.336-.948,1.242-.948a3.26,3.26,0,0,1,1,.189Z",
    transform: "translate(-524.851 -473.118)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(635.74 267.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M545.73,521.96a.379.379,0,1,1-.38.38.382.382,0,0,1,.38-.38",
    transform: "translate(-553.203 -499.863)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoVale, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_vale.a9a6c3b5.svg";
export { ForwardRef as ReactComponent };